import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Youtube } from 'lucide-react';
import NeuraliaLogo from './NeuraliaLogo';
import { SOCIAL_URLS } from '../lib/socialLinks';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-golden-xl border-t border-border-subtle" data-testid="footer">
      <div className="max-w-7xl mx-auto px-golden-md lg:px-golden-lg">
        <div className="grid md:grid-cols-4 gap-golden-xl mb-golden-xl">
          {/* Logo + description */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-golden-md">
              <NeuraliaLogo size={40} />
              <span className="font-heading font-bold text-xl tracking-tight text-text-heading">
                Neuralia <span className="bg-[linear-gradient(to_right,#EA4335,#FBBC05,#34A853,#4285F4)] bg-clip-text text-transparent">369</span>
              </span>
            </div>
            <p className="text-text-muted text-sm leading-relaxed">
              Soluciones de IA para captar mejor, seguir mejor, atender mejor y operar con más control.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-text-heading font-semibold mb-golden-md text-sm uppercase tracking-wider">Servicios</h4>
            <div className="flex flex-col gap-2">
              <Link to="/producto" className="text-text-muted hover:text-primary transition-colors text-sm">Producto</Link>
              <Link to="/que-es" className="text-text-muted hover:text-primary transition-colors text-sm">Qué es Neuralia 369</Link>
              <Link to="/comparativa" className="text-text-muted hover:text-primary transition-colors text-sm">Comparativa</Link>
              <Link to="/soluciones" className="text-text-muted hover:text-primary transition-colors text-sm">Soluciones</Link>
              <Link to="/developer" className="text-text-muted hover:text-primary transition-colors text-sm">Developer</Link>
              <Link to="/seguridad" className="text-text-muted hover:text-primary transition-colors text-sm">Seguridad</Link>
              <Link to="/nosotros" className="text-text-muted hover:text-primary transition-colors text-sm">Nosotros</Link>
              <Link to="/contacto" className="text-text-muted hover:text-primary transition-colors text-sm">Contacto</Link>
              <Link to="/precios" className="text-text-muted hover:text-primary transition-colors text-sm">Precios</Link>
              <Link to="/partners" className="text-text-muted hover:text-primary transition-colors text-sm">Programa Partners</Link>
              <Link to="/developers" className="text-text-muted hover:text-primary transition-colors text-sm">Developers · MCP</Link>
              <Link to="/app-movil" className="text-text-muted hover:text-primary transition-colors text-sm">App Móvil</Link>
              <Link to="/tendencias" className="text-text-muted hover:text-primary transition-colors text-sm">Tendencias 2026</Link>
              <Link to="/experiencia" className="text-text-muted hover:text-primary transition-colors text-sm">Experiencia 3D</Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-text-heading font-semibold mb-golden-md text-sm uppercase tracking-wider">Legal</h4>
            <div className="flex flex-col gap-2">
              <Link to="/aviso-legal" className="text-text-muted hover:text-primary transition-colors text-sm">Aviso Legal</Link>
              <Link to="/privacidad" className="text-text-muted hover:text-primary transition-colors text-sm">Privacidad</Link>
              <Link to="/cookies" className="text-text-muted hover:text-primary transition-colors text-sm">Cookies</Link>
              <Link to="/terminos" className="text-text-muted hover:text-primary transition-colors text-sm">Términos</Link>
            </div>
          </div>

          {/* Contact + Social */}
          <div>
            <h4 className="text-text-heading font-semibold mb-golden-md text-sm uppercase tracking-wider">Contacto</h4>
            <div className="flex flex-col gap-2 mb-golden-lg">
              <a href="mailto:contacto@neuralia369.com" className="text-text-muted hover:text-primary transition-colors text-sm">
                contacto@neuralia369.com
              </a>
              <a href="https://wa.me/17872981758" className="text-text-muted hover:text-primary transition-colors text-sm" target="_blank" rel="noopener noreferrer">
                +1 (787) 298-1758
              </a>
            </div>
            <div className="flex items-center gap-3">
              <a href={SOCIAL_URLS.facebook} target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-primary transition-colors" aria-label="Facebook" data-testid="footer-social-facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href={SOCIAL_URLS.youtube} target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-primary transition-colors" aria-label="YouTube" data-testid="footer-social-youtube">
                <Youtube className="w-5 h-5" />
              </a>
              <a href={SOCIAL_URLS.tiktok} target="_blank" rel="noopener noreferrer" className="text-text-muted hover:text-primary transition-colors" aria-label="TikTok" data-testid="footer-social-tiktok">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.44V13.1a8.16 8.16 0 005.58 2.2V11.9a4.85 4.85 0 01-3.59-1.59V6.69h3.59z" /></svg>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-golden-md pt-golden-lg border-t border-border-subtle">
          <p className="text-text-muted text-sm text-center md:text-left">
            &copy; {currentYear} Neuralia 369 LLC. Todos los derechos reservados.
          </p>
          <p className="text-text-muted text-xs text-center md:text-right">
            Calle San Judas 214, Barrio Corazón, Guayama 00784, Puerto Rico
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
